import http from '@/utils/http';

const baseUrl = '/monitoramento/socioambiental';

export default {
    pesquisar(filtro) {
        return http.get({
            url: baseUrl + `/pesquisa-inteligente?filtro=${filtro}`,
            lockScreen: false
        });
    },

    buscarTotalizadores(body) {
        return http.post({
            url: baseUrl + '/totalizador',
            data: body,
            lockScreen: false
        });
    },

    buscarAreaMonitoradaPorId(id) {
        return http.get({
            url: baseUrl + `/areas-monitoradas/${id}`,
            lockMessage: 'Buscando dados da área monitorada'
        });
    },

    enviarAreasMonitoramento(body) {
        return http.post({
            url: baseUrl + `/salvar/area-monitoramento`,
            data: body,
            lockScreen: false,
            lockMessage: 'Enviando território para monitoramento'
        });
    },

    consultaRelatorio(body, { page, size, sort }) {
        return http.post({
            url:
                baseUrl +
                `/filtrar-relatorio?page=${page - 1}&size=${size}&sort=${sort}`,
            data: body,
            lockScreen: true,
            lockMessage: 'Buscando dados de monitoramento'
        });
    },

    buscarRelatorioGrafico(body) {
        return http.post({
            url: baseUrl + `/grafico`,
            data: body,
            lockScreen: true,
            lockMessage: 'Buscando dados do gráfico'
        });
    },

    exportarRelatorio(body) {
        const fileLink = document.createElement('a');
        try {
            return http
                .post({
                    url: baseUrl + '/requisicao-xlsx',
                    data: body,
                    responseType: 'blob',
                    lockScreen: true,
                    lockMessage: 'Preparando dados para download'
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;
                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    buscarTerritoriosNaoMonitorados(
        filtros,
        { pagina, ordenacao, tamanho = 20 }
    ) {
        return http.post({
            url:
                baseUrl +
                `/nao-monitorados?page=${pagina}&sort=${ordenacao}&size=${tamanho}`,
            data: JSON.parse(JSON.stringify(filtros)),
            lockScreen: false
        });
    },

    consultaDiagnosticoPorIdETerritorioId(
        idDiagnosticoSocioambiental,
        idTerritorio
    ) {
        return http.get({
            url:
                baseUrl +
                `/${idDiagnosticoSocioambiental}/territorio/${idTerritorio}`,
            lockScreen: true,
            lockMessage: 'Buscando dados de diagnósticos socioambiental'
        });
    },

    buscarSituacaoCamadaCategoria(filtro) {
        return http.post({
            url: baseUrl + `/situacao`,
            data: filtro,
            lockScreen: true,
            lockMessage: 'Buscando situação'
        });
    },

    buscarSituacaoPorCar(input) {
        return http.post({
            url: baseUrl + `/situacao/car`,
            data: input,
            lockScreen: true,
            lockMessage: 'Buscando situação'
        });
    },
    buscarAlertasAreasMonitoradasSocioambiental(filtro) {
        const baseUrl_ = '/alertas';

        return http.get({
            url: baseUrl_ + `/areasMonitoradas?filtro=${filtro}`,
            lockScreen: true,
            lockMessage: 'Buscando alertas'
        });
    }
};
